import { ca } from '@cian/analytics';

export const trackBubbleInputSend = (chatId: string, bubbleType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Bubble',
    action: 'Send_sopr',
    label: 'Text',
    page: {
      extra: {
        chat_id: chatId,
        bubble_type: bubbleType,
      },
    },
  });
};
